import { Serializable } from '../../../core/models/serializable';
import { PortfolioModel } from './portfolio-model';

export class PortfolioListRecordModel
  implements Serializable<PortfolioListRecordModel>
{
  fromObject(object: any): PortfolioListRecordModel {
    Object.assign(this, object);

    if (object.portfolio != null) {
      let t = new PortfolioModel();
      t = t.fromObject(object.portfolio);
      this.portfolio = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public portfolio: PortfolioModel;
  public activeAnnouncementTotal: number;
  public activeDbProductTotal: number;
  public activeCvBoxProductTotal: number;
  public activeSliderTotal: number;
  public customerTotal: number;
  public approvedMatches: number;
  public totalDebt: number;

  constructor() {
    this.portfolio = new PortfolioModel();
  }
}
